import { BrandMark } from "@cntrl/ui";
import styles from "./AvMark.module.scss";

/**
 * The crimson AV "full access" mark for a `band_member_av` seat, for surfaces that render a role as PLAIN
 * TEXT and so cannot route through {@link RoleLabel} — a picker `<option>` row, a mono role chip whose words
 * were already resolved upstream (and may be an ORG role, which `RoleLabel` would mislabel). Renders NOTHING
 * for any other role, so a caller can hand it whatever role key a row carries.
 *
 * Decorative (`aria-hidden`): the words carry the job; this is a visual-only permission cue (ART-171). Where
 * you have the role AND the title, prefer `RoleLabel` — it owns the words, the owner "Artist" rule and the
 * "(Full Access)" picker spelling too. This is only for the "I already have the label string" case.
 */
export function AvMark({ roleKey }: { roleKey?: string | null }) {
  if (roleKey !== "band_member_av") return null;
  return <BrandMark decorative className={styles.mark} />;
}
